
import { ConfigTabProps } from "./types";
import { Label } from "@/components/ui/label";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { availableKnowledgeBases } from "../data";
import { KnowledgeBaseToggle } from "./KnowledgeBaseToggle";
import { AgentKnowledgeBase } from "@/components/candidates/types/agent";

export const KnowledgeConfigTab = ({ selectedAgent, updateAgentConfig }: ConfigTabProps) => {
  const handleKnowledgeBaseToggle = (kbId: string, isEnabled: boolean) => {
    const updatedKnowledgeBases = selectedAgent.knowledgeBases.map(kb => 
      kb.id === kbId ? { ...kb, isEnabled } : kb
    );
    updateAgentConfig({ knowledgeBases: updatedKnowledgeBases });
  };
  
  const removeKnowledgeBase = (kbId: string) => {
    const updatedKnowledgeBases = selectedAgent.knowledgeBases.filter(kb => kb.id !== kbId);
    updateAgentConfig({ knowledgeBases: updatedKnowledgeBases });
  };
  
  const addKnowledgeBase = (kbId: string) => {
    const kb = availableKnowledgeBases.find(kb => kb.id === kbId);
    if (kb && !selectedAgent.knowledgeBases.some(existing => existing.id === kbId)) {
      const newKnowledgeBase: AgentKnowledgeBase = {
        id: kb.id,
        name: kb.name,
        description: kb.description,
        documentCount: kb.documentCount,
        lastUpdated: kb.lastUpdated,
        isEnabled: true
      };
      const updatedKnowledgeBases = [...selectedAgent.knowledgeBases, newKnowledgeBase];
      updateAgentConfig({ knowledgeBases: updatedKnowledgeBases });
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <div className="flex items-center justify-between mb-2">
          <Label>Knowledge Bases</Label>
          <Select onValueChange={addKnowledgeBase}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Add Knowledge Base" />
            </SelectTrigger>
            <SelectContent>
              {availableKnowledgeBases
                .filter(kb => !selectedAgent.knowledgeBases.some(agentKb => agentKb.id === kb.id))
                .map(kb => (
                  <SelectItem key={kb.id} value={kb.id}>
                    {kb.name}
                  </SelectItem>
                ))}
            </SelectContent>
          </Select>
        </div>
        
        <ScrollArea className="h-[300px] border rounded-md p-4">
          <div className="space-y-4">
            {selectedAgent.knowledgeBases.length > 0 ? (
              selectedAgent.knowledgeBases.map(kb => (
                <KnowledgeBaseToggle
                  key={kb.id}
                  kb={kb}
                  onToggle={(enabled) => handleKnowledgeBaseToggle(kb.id, enabled)}
                  onRemove={() => removeKnowledgeBase(kb.id)}
                />
              ))
            ) : (
              <div className="text-center py-8 text-muted-foreground">
                No knowledge bases added yet
              </div>
            )}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
};
